// @flow
import { createSelector } from 'reselect';
import { getStation } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import type { AppState, SalesState } from '../../../types/State';

export function getSalesState(state: AppState): SalesState {
  return state.sales;
}

export function getHistoryState(state: AppState) {
  return state.sales.estimation.history;
}

export const getHistory = createSelector([getHistoryState], (history) => {
  return history.estimations.sort((a, b) => b.compareTo(a));
});

export function getProgress(state: AppState) {
  return state.sales.estimation.progress;
}

export const getCurrentStationProgress = createSelector([getProgress, getStation], (progress, currentStation) => {
  return progress[currentStation] || [];
});

export function getStationProgress(state: AppState, station: string) {
  return getProgress(state)[station] || [];
}

export const getEstimationsNewlyCalculated = createSelector([getProgress, getStation], (progress, station) => {
  return (progress[station] || []).filter(p => p.progress.is('SUCCESS')).map(p => p.progress.reference);
});

export const getNumberOfEstimationsCalculated = createSelector([getEstimationsNewlyCalculated], (newlyCalculated) => {
  return newlyCalculated.length;
});



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/selectors/salesSelectors.js